/**
 * Created by Ning Jiang on 6/10/2019.
 */
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";

export class PPGameMode extends GameMode{
    public static readonly NORMAL:string = "NORMAL";
    public static readonly FREESPIN_PICK:string = "FREESPIN_PICK";
    public static readonly FREESPIN:string = "FREESPIN";
}